import React from 'react';
import moment from 'moment';

import { Icon } from 'semantic-ui-react';
import './style.css';

export const BoundaryWarning = ({ campaignDetails }) => {
  const { videos, maxVideos, expiryTime} = campaignDetails
 
  const today = moment(new Date);
  const days = moment(expiryTime).diff(today, 'days');
  const amount = maxVideos ? maxVideos - videos.length : false

  if(!maxVideos && !expiryTime) return false;
  return (
    <div className='boundary-warning'>
      <Icon name='warning circle' color='black' />
      {!!days && (
        <p>
          You have <strong>{days} days</strong> left to upload your videos
        </p>
      )}
      {!days && (
        <p>
          This campaign can still receive <strong>{amount}</strong> videos.
          Send yours not to be left out.
        </p>
      )}
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/BoundaryWarning/index.jsx